import { render, staticRenderFns } from "./ClientInfoCard.vue?vue&type=template&id=62b4586c&"
import script from "./ClientInfoCard.vue?vue&type=script&lang=js&"
export * from "./ClientInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports